import { OptionType } from '@evinced-private/ui-common';

import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

import { buildKeyToDisplayNameMap, extractLabelKey } from '../../helpers/helpers';
import { TestRowSharedType } from '../../helpers/types';

export const extractExistingLabels = (
	testRows: TestRowSharedType[],
	tenantConfiguredLabels?: ConfigurationLabel[]
): OptionType[] => {
	if (!testRows?.length) {
		return [];
	}

	const keyToDisplayName = buildKeyToDisplayNameMap(tenantConfiguredLabels ?? []);

	const uniqueLabels = new Set<string>();
	testRows.forEach((row: TestRowSharedType) => {
		const labels = row?.labels ?? [];
		labels.forEach((label: string) => {
			if (extractLabelKey(label)) {
				uniqueLabels.add(label);
			}
		});
	});

	return [...uniqueLabels]
		.map((label) => {
			const colonIndex = label.indexOf(':');
			if (colonIndex > 0) {
				const key = label.substring(0, colonIndex);
				const value = label.substring(colonIndex + 1);
				const displayName = keyToDisplayName.get(key.toLowerCase()) ?? key;
				return { value: label, label: `${displayName}:${value}` };
			}
			return { value: label, label };
		})
		.sort((a, b) => a.label.localeCompare(b.label));
};
